import { cn } from '@/lib/utils'
import type { ComponentProps } from 'react'

export type CardDisclosureTriggerProps = ComponentProps<'button'>

function CardDisclosureTrigger({
  className,
  type = 'button',
  ...props
}: CardDisclosureTriggerProps) {
  return (
    <button
      {...props}
      type={type}
      data-slot="card-disclosure-trigger"
      className={cn(
        'w-full cursor-pointer text-left outline-none transition-colors hover:bg-muted/30 focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-ring disabled:cursor-not-allowed disabled:text-muted-foreground',
        className
      )}
    />
  )
}

export { CardDisclosureTrigger }
